export function getFileLocation(props) {
    if ('itemId' in props) {
        return "".concat(props.drivePath, "items/").concat(props.itemId, "/");
    }
    var drivePath = props.drivePath, file = props.file, parent = props.parent, path = props.path;
    var destination = path
        ? "root:/".concat(path, "/")
        : parent
            ? "items/".concat(parent, ":/")
            : "root:/";
    return "".concat(drivePath).concat(destination).concat(encodeURIComponent(file.name), ":/");
}
//# sourceMappingURL=getFileLocation.js.map